import {
	IonButton,
	IonCard,
	IonCardHeader,
	IonCol,
	IonGrid,
	IonItem,
	IonRow,
	IonText,
	IonIcon,
	IonAlert,
	useIonLoading,
	IonToast,
} from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { headersDefault } from '../../redux/actions'
import config from '../../settings/config'
import { updateUserProperty } from '../../redux/reducer/userSlice'
import { Icon } from '@iconify/react'

const DietButtons = ({ profile = false }) => {
	const backUrl = config.env[config.env.mode].url
	const dispatch = useDispatch()
	const { master_club_subscriber } = useSelector((state) => state.user)
	const [ionLoading, hideIonLoading] = useIonLoading()

	const subscriptionName =
		useSelector(
			(state) =>
				state.user?.master_club_subscriber?.subscription?.subscription_type
					?.name
		) ?? null

	const currentProtocol =
		useSelector((state) => state.user?.master_club_subscriber?.protocols?.current) ||
		''
	const nextProtocol =
		useSelector((state) => state.user?.master_club_subscriber?.protocols?.next_week) ||
		''
	const possibleCurrentProtocols =
		useSelector((state) => state.user?.master_club_subscriber?.protocols?.possible?.current) ||
		[]
	const possibleNextProtocols =
		useSelector((state) => state.user?.master_club_subscriber?.protocols?.possible?.next_week) ||
		[]

	const [vegetarian, setVegetarian] = useState(
		master_club_subscriber?.vegetarian || false
	)
	const [glutenFree, setGlutenFree] = useState(
		master_club_subscriber?.gluten_free || false
	)

	const [keep_weight, setKeepWeight] = useState(
		master_club_subscriber?.keep_weight || false
	)

	const [toast, setToast] = useState({
		message: '',
		open: false,
	})

	const v = vegetarian ? 'VEGETARIANO' : 'ONNIVORO'
	const vColor = vegetarian ? 'primary' : 'blue'
	const k = keep_weight ? 'MANTENIMENTO' : 'DIMAGRIMENTO'
	const kColor = keep_weight ? 'blue' : 'primary'
	const g = glutenFree ? 'SI' : 'NO'
	const gColor = glutenFree ? 'primary' : 'light'

	// Function to get current Monday date
	const getCurrentMondayDate = () => {
		const today = new Date()
		const currentDay = today.getDay() // 0 = Sunday, 1 = Monday, etc.
		const daysFromMonday = currentDay === 0 ? 6 : currentDay - 1
		const currentMonday = new Date(today)
		currentMonday.setDate(today.getDate() - daysFromMonday)
		return currentMonday.toISOString().split('T')[0] // Format: YYYY-MM-DD
	}

	// Function to get current Sunday date
	const getCurrentSundayDate = () => {
		const currentMonday = new Date(getCurrentMondayDate())
		const currentSunday = new Date(currentMonday)
		currentSunday.setDate(currentMonday.getDate() + 6)
		return currentSunday.toISOString().split('T')[0] // Format: YYYY-MM-DD
	}

	// Function to get next Monday date
	const getNextMondayDate = () => {
		const today = new Date()
		const currentDay = today.getDay() // 0 = Sunday, 1 = Monday, etc.
		const daysUntilNextMonday = currentDay === 0 ? 1 : 8 - currentDay
		const nextMonday = new Date(today)
		nextMonday.setDate(today.getDate() + daysUntilNextMonday)
		return nextMonday.toISOString().split('T')[0] // Format: YYYY-MM-DD
	}

	// Function to get next Sunday date
	const getNextSundayDate = () => {
		const nextMonday = new Date(getNextMondayDate())
		const nextSunday = new Date(nextMonday)
		nextSunday.setDate(nextMonday.getDate() + 6)
		return nextSunday.toISOString().split('T')[0] // Format: YYYY-MM-DD
	}

	const setToastIsOpen = (message) => {
		setToast({
			message,
			open: true,
		})
	}

	const postProtocolTimeline = (protocolId, startDate, endDate) =>
		fetch(`${backUrl}/api/v1/master-club-protocol-timeline`, {
			method: 'POST',
			body: JSON.stringify({
				protocol_id: protocolId,
				start_date: startDate,
				end_date: endDate,
			}),
			headers: headersDefault(),
		}).then((response) => {
			if (!response.ok) throw new Error('fetch error')
			return response.json()
		})

	const handleProtocolChange = (protocolId, weekType) => {
		ionLoading({ message: 'Aggiornando protocolli...' })

		const currentStart = getCurrentMondayDate()
		const currentEnd = getCurrentSundayDate()
		const nextStart = getNextMondayDate()
		const nextEnd = getNextSundayDate()

		let currentProtocolId
		let nextProtocolId

		if (weekType === 'current') {
			currentProtocolId = protocolId
			const isInNextWeekPossible = possibleNextProtocols.some((p) => p.id === protocolId)
			nextProtocolId = isInNextWeekPossible ? protocolId : (nextProtocol?.protocol_id ?? null)
		} else {
			currentProtocolId = currentProtocol?.protocol_id ?? null
			nextProtocolId = protocolId
		}

		const promises = []
		if (currentProtocolId != null) {
			promises.push(postProtocolTimeline(currentProtocolId, currentStart, currentEnd))
		}
		if (nextProtocolId != null) {
			promises.push(postProtocolTimeline(nextProtocolId, nextStart, nextEnd))
		}

		Promise.all(promises)
			.then(() => {
				const nextState = { ...master_club_subscriber.protocols }
				const currentSelected = possibleCurrentProtocols.find((p) => p.id === currentProtocolId)
				const nextSelected = possibleNextProtocols.find((p) => p.id === nextProtocolId)
				if (currentSelected) {
					nextState.current = {
						...currentProtocol,
						protocol_id: currentProtocolId,
						protocol: { id: currentSelected.id, name: currentSelected.name },
					}
				}
				if (nextSelected) {
					nextState.next_week = {
						...nextProtocol,
						protocol_id: nextProtocolId,
						protocol: { id: nextSelected.id, name: nextSelected.name },
					}
				}
				dispatch(
					updateUserProperty({
						stateKey: 'master_club_subscriber',
						key: 'protocols',
						value: nextState,
					})
				)
				hideIonLoading()
				setToastIsOpen('Preferenze protocollo aggiornate!')
			})
			.catch((e) => {
				hideIonLoading()
				setToastIsOpen("Ops! C'è stato un errore. Riprova più tardi.")
				console.log(e)
			})
	}

	const handleGlfClick = () => {
		setGlutenFree(!glutenFree)
	}

	const handleVegetarianClick = () => {
		setVegetarian(!vegetarian)
	}

	const handleKeepWeightClick = () => {
		setKeepWeight(!keep_weight)
	}

	useEffect(() => {
		updateInput()
	}, [glutenFree, vegetarian, keep_weight])

	useEffect(() => {
		if (subscriptionName !== 'premium' && keep_weight) {
			setKeepWeight(false)
		}
	}, [])

	const updateInput = () => {
		const body = JSON.stringify({
			...{ vegetarian },
			...{ keep_weight },
			...{ gluten_free: glutenFree },
		})
		fetch(`${backUrl}/api/master-club-subscribers/1`, {
			method: 'PATCH',
			body,
			headers: headersDefault(),
		})
			.then((response) => {
				if (!response.ok) throw new Error('fetch error')
				return response.json()
			})
			.then((data) => {
				dispatch(
					updateUserProperty({
						stateKey: 'master_club_subscriber',
						key: 'gluten_free',
						value: glutenFree,
					})
				)

				dispatch(
					updateUserProperty({
						stateKey: 'master_club_subscriber',
						key: 'vegetarian',
						value: vegetarian,
					})
				)
			})
			.catch((e) => console.log(e))
	}

	const Profile = (
		<>
			<IonGrid className="ion-margin-vertical ion-no-padding">
				<IonRow>
					<IonCol
						sizeSm="4"
						sizeXs="12">
						<IonButton
							onClick={handleVegetarianClick}
							className="disable-click"
							color={vColor}>
							{v}
						</IonButton>
						<IonText
							color="medium"
							style={{ display: 'block' }}>
							<div className="label">Tipo di alimentazione</div>
						</IonText>
					</IonCol>
					<IonCol
						sizeSm="4"
						sizeXs="12">
						<IonButton
							onClick={handleKeepWeightClick}
							className="disable-click"
							disabled={subscriptionName !== 'premium'}
							color={kColor}>
							{k}
						</IonButton>
						<IonText
							color="medium"
							style={{ display: 'block' }}>
							<div className="label">Obiettivo</div>
						</IonText>
					</IonCol>
					<IonCol
						sizeSm="4"
						sizeXs="12">
						<IonButton
							onClick={handleGlfClick}
							className="disable-click"
							color={gColor}>
							{g}
						</IonButton>
						<IonText
							color="medium"
							style={{ display: 'block' }}>
							<div className="label">Senza glutine e lattosio</div>
						</IonText>
					</IonCol>
				</IonRow>
				<IonRow>
					<IonCol
						sizeSm="6"
						sizeXs="12">
						{possibleCurrentProtocols.length > 1 && subscriptionName === 'premium' ? (
							<IonButton
								id="change-current-protocol-trigger"
								fill="solid"
								expand="block"
								color="warning">
								<Icon
									icon="material-symbols:edit"
									width={16}
									height={16}
									style={{ marginRight: '8px' }}
								/>
								{currentProtocol?.protocol?.name || 'Standard'}
							</IonButton>
						) : (
							<IonButton
								className="disable-click"
								expand="block"
								color="warning">
								{currentProtocol?.protocol?.name || 'Standard'}
							</IonButton>
						)}
						<IonText
							color="medium"
							style={{ display: 'block' }}>
							<div className="label">Protocollo attuale</div>
						</IonText>
					</IonCol>
					<IonCol
						sizeSm="6"
						sizeXs="12">
						{possibleNextProtocols.length > 1 && subscriptionName === 'premium' ? (
							<IonButton
								id="change-next-protocol-trigger"
								fill="solid"
								expand="block"
								color="danger">
								<Icon
									icon="material-symbols:edit"
									width={16}
									height={16}
									style={{ marginRight: '8px' }}
								/>
								{nextProtocol?.protocol?.name || 'Standard'}
							</IonButton>
						) : (
							<IonButton
								className="disable-click"
								expand="block"
								disabled={subscriptionName !== 'premium'}
								color="danger"
								fill="outline">
								{nextProtocol?.protocol?.name || 'Standard'}
							</IonButton>
						)}
						<IonText
							color="medium"
							style={{ display: 'block' }}>
							<div className="label">Protocollo prossima settimana</div>
						</IonText>
					</IonCol>
				</IonRow>
			</IonGrid>
			
			{/* Alert for current week protocol */}
			<IonAlert
				trigger="change-current-protocol-trigger"
				header="Seleziona protocollo"
				subHeader="Scegli il protocollo per la settimana corrente"
				buttons={[
					{
						text: 'Annulla',
						role: 'cancel',
					},
					{
						text: 'Conferma',
						role: 'confirm',
						handler: (data) => {
							if (data && data !== currentProtocol?.protocol_id) {
								handleProtocolChange(parseInt(data), 'current')
							}
						},
					},
				]}
				inputs={possibleCurrentProtocols.map((protocol) => ({
					type: 'radio',
					label: protocol.name,
					value: protocol.id,
					checked: protocol.id === currentProtocol?.protocol_id,
				}))}
			/>

			{/* Alert for next week protocol */}
			<IonAlert
				trigger="change-next-protocol-trigger"
				header="Seleziona protocollo"
				subHeader="Scegli il protocollo per la prossima settimana"
				buttons={[
					{
						text: 'Annulla',
						role: 'cancel',
					},
					{
						text: 'Conferma',
						role: 'confirm',
						handler: (data) => {
							if (data && data !== nextProtocol?.protocol_id) {
								handleProtocolChange(parseInt(data), 'next_week')
							}
						},
					},
				]}
				inputs={possibleNextProtocols.map((protocol) => ({
					type: 'radio',
					label: protocol.name,
					value: protocol.id,
					checked: protocol.id === nextProtocol?.protocol_id,
				}))}
			/>

			<IonToast
				isOpen={toast.open}
				message={toast.message}
				duration={3000}
				onDidDismiss={() => setToast({ ...toast, open: false })}
			/>
		</>
	)

	const Card = (
		<IonCard>
			<IonCardHeader>Le tue preferenze alimentari</IonCardHeader>
			<IonItem>
				<b>Tipo di alimentazione:</b>
				<IonButton
					onClick={handleVegetarianClick}
					color={vColor}>
					{v}
				</IonButton>
			</IonItem>
			<IonItem>
				<b>Obiettivo:</b>
				<IonButton
					onClick={handleKeepWeightClick}
					disabled={subscriptionName !== 'premium'}
					color={kColor}>
					{k}
				</IonButton>
			</IonItem>
			<IonItem>
				<b>Senza glutine e lattosio:</b>
				<IonButton
					onClick={handleGlfClick}
					color={gColor}>
					{g}
				</IonButton>
			</IonItem>
		</IonCard>
	)

	return profile ? Profile : Card
}

export default DietButtons
